module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLight.5aa4afd4.woff2";